(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function width(el) { return el.getBoundingClientRect().width; }

    function build(section) {
      var viewport = section.querySelector('.lm-viewport');
      var track = section.querySelector('.lm-track');
      if (!viewport || !track) return;
      var first = track.querySelector('.lm-group');
      if (!first) return;

      // reset (handles theme-editor re-render + resize)
      Array.prototype.forEach.call(
        track.querySelectorAll('.lm-group[data-clone]'),
        function (n) { n.remove(); }
      );
      section.classList.remove('lm--ready');
      track.style.removeProperty('--lm-shift');
      track.style.animationDuration = '';

      var speed = parseFloat(section.getAttribute('data-px-per-sec')) || 60;
      var groupW = width(first);
      if (groupW < 1) return;

      // clone until the track is at least ~2x the viewport, so it never
      // shows empty space regardless of how many logos were added
      var copies = Math.max(2, Math.ceil((viewport.offsetWidth * 2) / groupW) + 1);
      for (var i = 1; i < copies; i++) {
        var c = first.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-clone', '');
        track.appendChild(c);
      }

      // one loop = distance between two identical groups → seamless
      var groups = track.querySelectorAll('.lm-group');
      var shift = groups[1].offsetLeft - groups[0].offsetLeft;
      if (shift < 1) return;

      track.style.setProperty('--lm-shift', shift + 'px');
      track.style.animationDuration = (shift / speed) + 's'; // constant speed
      section.classList.add('lm--ready');
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('.lm'), build);
    }

    var raf;
    function onResize() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(initAll);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    window.addEventListener('load', initAll);       // re-measure after images load
    window.addEventListener('resize', onResize);

    // Shopify theme editor
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.lm'); if (s) build(s);
    });
    document.addEventListener('shopify:section:select', function (e) {
      var s = e.target.querySelector('.lm'); if (s) build(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-marquee2b"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function buildTrack(track) {
      var viewport = track.closest('.lm-viewport');
      var first = track.querySelector('.lm-group');
      if (!viewport || !first) return;

      Array.prototype.forEach.call(
        track.querySelectorAll('.lm-group[data-clone]'),
        function (n) { n.remove(); }
      );
      track.classList.remove('is-ready');
      track.style.removeProperty('--lm-shift');
      track.style.animationDuration = '';

      var speed = parseFloat(track.getAttribute('data-px-per-sec')) || 60;
      var groupW = first.getBoundingClientRect().width;
      if (groupW < 1) return;

      // clone until each row is at least ~2x the viewport wide
      var copies = Math.max(2, Math.ceil((viewport.offsetWidth * 2) / groupW) + 1);
      for (var i = 1; i < copies; i++) {
        var c = first.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-clone', '');
        track.appendChild(c);
      }

      var groups = track.querySelectorAll('.lm-group');
      var shift = groups[1].offsetLeft - groups[0].offsetLeft;
      if (shift < 1) return;

      track.style.setProperty('--lm-shift', shift + 'px');
      track.style.animationDuration = (shift / speed) + 's'; // constant speed
      track.classList.add('is-ready');
    }

    function build(scope) {
      Array.prototype.forEach.call(
        (scope || document).querySelectorAll('.lm-track'),
        buildTrack
      );
    }

    var raf;
    function onResize() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { build(document); });
    }

    if (document.readyState !== 'loading') build(document);
    else document.addEventListener('DOMContentLoaded', function () { build(document); });
    window.addEventListener('load', function () { build(document); });
    window.addEventListener('resize', onResize);

    document.addEventListener('shopify:section:load', function (e) { build(e.target); });
    document.addEventListener('shopify:section:select', function (e) { build(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
